import { START_LOADER, STOP_LOADER } from '../reducers/loader-reducer'
import { SET_EXPORT_LOADER, SET_TABLEUR_LOADER } from '../reducers/tableur-reducer'

export const setLoader = (loader = false) =>
  loader ? { type: START_LOADER } : { type: STOP_LOADER }

export const setTableurLoader = (value = false) => ({type: SET_TABLEUR_LOADER, value})

export const setExportLoader = (value = false) => ({type: SET_EXPORT_LOADER, value})
